import React from "react";
const Skills = () => (
  <div className="card shadow mb-4">
    <div className="card-header py-3">
      <h6 class="m-0 font-weight-bold text-primary">Skills</h6>
    </div>

    <div class="card-body">
      <h4 class="small font-weight-bold">
        Front End <span class="float-right">90%</span>
      </h4>
      <div class="progress mb-4">
        <div
          class="progress-bar bg-success"
          role="progressbar"
          style={{ width: "90%" }}
        ></div>
      </div>
      <h4 class="small font-weight-bold">
        Server Side <span class="float-right">80%</span>
      </h4>
      <div class="progress mb-4">
        <div
          class="progress-bar bg-info"
          role="progressbar"
          style={{ width: "80%" }}
        ></div>
      </div>
      <h4 class="small font-weight-bold">
        Database <span class="float-right">60%</span>
      </h4>
      <div class="progress mb-4">
        <div
          class="progress-bar"
          role="progressbar"
          style={{ width: "60%" }}
        ></div>
      </div>
      <h4 class="small font-weight-bold">
        DevOps <span class="float-right">50%</span>
      </h4>
      <div class="progress mb-4">
        <div
          class="progress-bar bg-danger"
          role="progressbar"
          style={{ width: "50%" }}
        ></div>
      </div>
    </div>
  </div>
);

export default Skills;
